import WorkOsIpcRenderer from '@renderer/ipc/WorkOsIpc.renderer'

/**
 * Opens the sign in page in the browser.
 *
 * When running in browser mode (window.highlightBrowserAuth is present),
 * delegates to the browser auth system which adds the required
 * `destination=browser` and `redirect_to` query params for the
 * OAuth redirect flow to work correctly.
 */
export async function showSignIn(screenHint?: 'sign-in' | 'sign-up'): Promise<void> {
  const browserAuth = (
    window as { highlightBrowserAuth?: { openSignIn: (h?: 'sign-in' | 'sign-up') => Promise<void> } }
  ).highlightBrowserAuth
  if (browserAuth) {
    await browserAuth.openSignIn(screenHint)
    return
  }

  // The main process opens the sign-in so it can bind the returning deep link to it.
  await WorkOsIpcRenderer.showSignIn(screenHint)
}
